/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Readpermission1Inputs */

const de__field_readpermission1 = /** @type {(inputs: _Field_Readpermission1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leserechte`)
};

/**

* @param {_Field_Readpermission1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_readpermission1 = /** @type {((inputs?: _Field_Readpermission1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Readpermission1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_readpermission1(inputs)
});
export { _field_readpermission1 as "_field_readPermission" }